import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import type { FC } from 'react';
import type { Banner, DefaultCmsDataResponse } from '@/api/cms/types';
import CooperateCustomers from '@/components/CooperateCustomers';
import Container from '@/components/layouts/Container';
import { WebInAppID } from '@/lib/common';

import HelpFormContent from '@/modules/customer/HelpFormContent';
import { serviceConfig } from '../../serviceConfig';
import {
  cooperateWarehouseData,
  warehouseFeaturesData,
} from '../cooperateData';
import CooperateFeatures from '../CooperateFeatures';
import CooperateServiceForm from '../CooperateServiceForm';
import CooperateWarehouseFulfillBanner from '../CooperateWarehouseFulfillBanner';
import WarehouseSameday from './WarehouseSameday';
import WarehouseStatistics from './WarehouseStatistics';

type Props = {
  // Declare WarehousePage props
  homeBannerData?: DefaultCmsDataResponse<Banner>;
};

export const WarehousePage: FC<Props> = ({ homeBannerData }) => {
  const { t } = useTranslation(serviceConfig.i18nNamespaces);
  const { query } = useRouter();
  const isAhadriverWebinapp = query.webinapp === WebInAppID.AHA_DRIVER;

  const bannerDesktop: string =
    homeBannerData?.attributes?.items
      ?.filter((item) => item.type === 'home' && item.desktop_image)
      .map((item) => ({
        url: item.desktop_image?.data?.attributes?.url,
      }))[0].url || '';

  return (
    <Container
      title="Dịch vụ Warehouse | Ahamove - Giải pháp doanh nghiệp"
      description="Dịch vụ Warehouse tại Ahamove, tối ưu chi phí cho doanh nghiệp: Miễn phí hoàn hàng, Thu hộ COD, đối soát 3 lần/tuần, cam kết giao hàng đúng hạn >95%"
      image_url={bannerDesktop}
    >
      <main
        className={classNames(
          'mt-header-mobile desktop:mt-header-desktop min-h-content flex w-full grow flex-col',
          {
            'desktop:!mt-0 !mt-0': isAhadriverWebinapp,
          }
        )}
      >
        <CooperateWarehouseFulfillBanner
          title="Giải pháp giao hàng nhanh nội thành với chi phí tối ưu cho doanh nghiệp"
          img="/static/images/service/banner-warehouse.webp"
          type="warehouse"
          href="/service/cooperate/warehouse/#registation-form"
        />
        <WarehouseStatistics />
        <CooperateFeatures
          items={warehouseFeaturesData}
          img="/static/images/service/features-warehouse.webp"
        />
        <CooperateCustomers
          title="Các đối tác tin tưởng sử dụng"
          items={cooperateWarehouseData}
          cols="3"
        />
        <WarehouseSameday />
        <HelpFormContent
          id="registation-form"
          form={
            <CooperateServiceForm type="service" service="sameday delivery" />
          }
        />
      </main>
    </Container>
  );
};
